module.exports = __webpack_public_path__ + "static/img/404.6262e8fb.png";